import { Component, forwardRef, Input } from '@angular/core';
import { languages } from '@shared/helpers/languages';
import { ILanguageOption } from '@shared/interfaces/various/ILanguageOption';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-language-selection',
    templateUrl: './language-selection.component.html',
    styleUrls: ['./language-selection.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => LanguageSelectionComponent),
            multi: true
        }
    ],
    standalone: false
})
export class LanguageSelectionComponent implements ControlValueAccessor {
    @Input() size = '18px';
    @Input() languages: string[] = ['en'];
    @Input() searchBar = true;
    options: ILanguageOption[] = languages;
    filterQuery: string;
    value: string;

    _selectedLanguage: ILanguageOption = languages.find(e => e.code === 'en');

    get selectedLanguage(): ILanguageOption {
        return this._selectedLanguage;
    }

    set selectedLanguage(val: ILanguageOption) {
        this._selectedLanguage = val;
        this.value = val?.code;
        this.propagateChange(this.value);
    }

    get filteredList(): ILanguageOption[] {
        return (
            this.filterQuery
                ? this.options.filter(e => e.name.toLowerCase().indexOf(this.filterQuery.toLowerCase()) >= 0)
                : this.options
        ).filter(e => this.languages?.includes(e.code));
    }

    getLabel(item: ILanguageOption | string): string {
        return (item as ILanguageOption)?.name || (item as string);
    }

    writeValue(value: any) {
        if (value !== undefined) {
            this.value = value;
        }
    }

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {
        /* Form control touched handler */
    }

    propagateChange = (_: any) => {
        // ControlValueAccessor callback placeholder
    };
}
